export const BONUS_HINT_LABELS = {
  use_for: '使用了 for 循环',
  use_function: '定义了函数',
  'fn:': '指定函数名'
}

export function defaultCodingConfig() {
  return {
    needInput: false,
    template: '',
    ioSpec: '',
    bonusHints: {
      useFor: false,
      useFunction: false,
      functionName: ''
    },
    testCases: []
  }
}

export function parseCodingOptions(raw) {
  if (!raw || !String(raw).trim().startsWith('{')) {
    const cfg = defaultCodingConfig()
    if (raw && String(raw).trim()) {
      cfg.ioSpec = String(raw).trim()
    }
    return cfg
  }
  try {
    const parsed = JSON.parse(String(raw))
    const bh = parsed.bonusHints || {}
    const cfg = {
      ...defaultCodingConfig(),
      ...parsed,
      needInput: parsed.needInput === true,
      bonusHints: {
        useFor: bh.useFor === true,
        useFunction: bh.useFunction === true,
        functionName: bh.functionName ? String(bh.functionName).trim() : ''
      },
      testCases: Array.isArray(parsed.testCases) ? parsed.testCases.map(normalizeTestCase) : []
    }
    if (parsed.needInput == null && cfg.testCases.some((tc) => tc.input && tc.input.trim())) {
      cfg.needInput = true
    }
    return cfg
  } catch (e) {
    return defaultCodingConfig()
  }
}

function normalizeTestCase(row, index) {
  const tc = row || {}
  return {
    id: tc.id || `case-${index + 1}`,
    isSample: tc.isSample === true || tc.sample === true,
    input: tc.input == null ? '' : String(tc.input),
    expectedOutput: tc.expectedOutput == null ? '' : String(tc.expectedOutput),
    score: 0
  }
}

export function serializeCodingOptions(config) {
  const cfg = config || defaultCodingConfig()
  const bh = cfg.bonusHints || {}
  const payload = {
    judgeType: 'stdio',
    needInput: cfg.needInput === true,
    timeLimitMs: 10000,
    template: cfg.template || '',
    ioSpec: cfg.ioSpec || '',
    testCases: (cfg.testCases || []).map((tc, i) => ({
      id: tc.id || (tc.isSample ? `sample-${i + 1}` : `hidden-${i + 1}`),
      isSample: !!tc.isSample,
      input: cfg.needInput ? (tc.input == null ? '' : String(tc.input)) : '',
      expectedOutput: tc.expectedOutput == null ? '' : String(tc.expectedOutput),
      score: 0
    }))
  }
  if (bh.useFor || bh.useFunction || (bh.functionName && String(bh.functionName).trim())) {
    payload.bonusHints = {
      useFor: !!bh.useFor,
      useFunction: !!bh.useFunction,
      functionName: bh.functionName ? String(bh.functionName).trim() : ''
    }
  }
  return JSON.stringify(payload)
}

export function newTestCase(index, sample = true, needInput = false) {
  return {
    id: sample ? `sample-${index + 1}` : `hidden-${index + 1}`,
    isSample: sample,
    input: needInput ? '' : '',
    expectedOutput: '',
    score: 0
  }
}

export function bonusHintLabel(ruleId) {
  if (!ruleId) return ''
  if (ruleId.startsWith('fn:')) {
    return `定义了函数 ${ruleId.slice(3)}`
  }
  return BONUS_HINT_LABELS[ruleId] || ruleId
}

export function caseStatusLabel(status) {
  const map = {
    AC: '通过',
    WA: '输出不匹配',
    TLE: '运行超时',
    RE: '运行错误',
    CE: '语法错误'
  }
  return map[status] || status || '-'
}

export function caseStatusClass(status) {
  if (status === 'AC') return 'text-success'
  if (status === 'TLE' || status === 'RE' || status === 'CE') return 'text-danger'
  return 'text-warning'
}

export async function runCodingCode(code) {
  const res = await fetch('/api/student/coding/run', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code })
  }).then((r) => r.json())
  if (!res || res.code !== 200) {
    throw new Error((res && res.message) || '运行失败')
  }
  return res.data || {}
}

export async function runCodingSample({ questionId, code, recordId }) {
  const res = await fetch('/api/student/coding/run-sample', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ questionId, code, recordId: recordId || null })
  }).then((r) => r.json())
  if (!res || res.code !== 200) {
    throw new Error((res && res.message) || '样例运行失败')
  }
  return res.data || {}
}

export function parseJudgeDetail(raw) {
  if (!raw) return null
  if (typeof raw === 'object') return raw
  try {
    return JSON.parse(String(raw))
  } catch (e) {
    return null
  }
}
